import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'
import Toggle from '../dataClass/Toggle'
import { apiActions } from '../api'

Vue.use(Vuex);

const state = {
    api: {
        
    },
    urlParams:{
        
    }
}
for (let i in apiActions) {
    let obj = {
        toggle: new Toggle,
        data: null,
    };
    Object.assign(state.api, { [i]: obj });
}
export default new Vuex.Store({
    state,
    actions,
    getters,
    mutations,
})


// WEBPACK FOOTER //
// ./src/store/index.js